// extracted by mini-css-extract-plugin
export var blur = "quote-gallery-module--blur--AD0Cm";
export var carouselSlide = "quote-gallery-module--carouselSlide--c8pu3";
export var quoteContainer = "quote-gallery-module--quoteContainer--tDb+O";
export var quoteGalleryContainer = "quote-gallery-module--quote-gallery-container--AqPLJ";